import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    sequenceNumber: 11,
    content: 'To what extent are synergies a critical factor to the deal?',
    subSection: 'Synergies',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Not Important', 'Somewhat Important', 'Very Important'],
    },
    compLocation: 'down',
  },
  {
    sequenceNumber: 12,
    content: 'How important are revenue synergies to the deal?',
    subSection: 'Synergies',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Not Important', 'Somewhat Important', ' Very Important'],
    },
    compLocation: 'down',
  },
  {
    sequenceNumber: 13,
    content:
      'What is the level of operational overlap (e.g., people, facilities, customers, supply chain) between the Buyer and Target?',
    subSection: 'Oprating Model',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['No Overlap', 'Some Overlap', ' Significant Overlap'],
    },
    compLocation: 'down',
  },
  {
    sequenceNumber: 14,
    content: 'How important are cost synergies to the deal?',
    subSection: 'Cost Synergies',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Not Important', 'Somewhat Important', ' Very Important'],
    },
    compLocation: 'down',
    cancelPointEvent: true,
  },
];
